var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiChipSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.689 70.5735C38.689 78.382 43.5759 83.917 51.412 83.917H73.8295C81.669 83.917 86.5285 78.382 86.5285 70.5735V49.4452C86.5285 41.6092 81.669 36.0742 73.8295 36.0742H51.412C43.5999 36.0742 38.689 41.6092 38.689 49.4452V70.5735Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.333 50.3225C55.175 50.3225 52.9365 52.2985 52.9365 55.4675V64.534C52.9365 67.7045 55.175 69.6695 58.333 69.6695H66.8775C70.0465 69.6695 72.285 67.7045 72.285 64.534V55.4675C72.285 52.3085 70.0465 50.3225 66.8775 50.3225H58.333Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.7219 36.0851V26.543",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.2876 36.0827V20.7715",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.722 15.0045C49.5357 15.0045 46.9527 17.5875 46.9527 20.7737C46.9527 23.96 49.5357 26.543 52.722 26.543C55.9082 26.543 58.4912 23.96 58.4912 20.7737C58.4912 17.5875 55.9082 15.0045 52.722 15.0045Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.2825 83.915V93.457",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.7175 83.917V99.2285",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2829 104.996C75.4692 104.996 78.0522 102.413 78.0522 99.2265C78.0522 96.0403 75.4692 93.4573 72.2829 93.4573C69.0967 93.4573 66.5137 96.0403 66.5137 99.2265C66.5137 102.413 69.0967 104.996 72.2829 104.996Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.4199 50.215H95.9619",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.4194 69.785H101.731",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 50.217C107.5 47.0307 104.917 44.4477 101.731 44.4477C98.5446 44.4477 95.9617 47.0307 95.9617 50.217C95.9617 53.4032 98.5446 55.9862 101.731 55.9862C104.917 55.9862 107.5 53.4032 107.5 50.217Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.5801 69.785H29.0381",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.5803 50.215H23.269",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 69.783C17.5001 72.9693 20.0831 75.5523 23.2693 75.5523C26.4556 75.5523 29.0386 72.9693 29.0386 69.783C29.0386 66.5968 26.4556 64.0138 23.2693 64.0138C20.0831 64.0138 17.5001 66.5968 17.5001 69.783Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChipSignup);
export default __webpack_public_path__ + "static/media/AiChipSignup.2146338186e8bc349130bab6a8ff2f62.svg";
export { ForwardRef as ReactComponent };